import { render, staticRenderFns } from "./PracticeFragment.vue?vue&type=template&id=fe8fdd3e"
import script from "./PracticeFragment.vue?vue&type=script&lang=js"
export * from "./PracticeFragment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports